module.exports = "<div class=\"_no-auth\">\n\n  <main>\n    <v-container fluid>\n      <v-layout>\n        <v-flex xs12 sm6 offset-sm3>\n          <v-card>\n            <v-card-title primary-title>\n              <div class=\"message-container\">\n                <h3 class=\"headline mb-0\">ATTENZIONE!</h3>\n                <p>Non hai i permessi per accedere a questa sezione.</p>\n              </div>\n            </v-card-title>\n          </v-card>\n        </v-flex>\n      </v-layout>\n    </v-container>\n  </main>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/noAuth/noAuth.vue
// module id = 377
// module chunks = 0